var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrashSimple = function SvgIconTrashSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 1.875a1 1 0 0 1 1-1h7.5a1 1 0 1 1 0 2h-7.5a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.75 5.625a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2h-.5V19.5A1.75 1.75 0 0 1 18 21.25H6a1.75 1.75 0 0 1-1.75-1.75V6.625h-.5a1 1 0 0 1-1-1m3.5 1V19.25h11.5V6.625z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconTrashSimple;